"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCombinedBoxId = exports.getIsLeadBuyer = exports.getBuyerOrgId = exports.getBuyerName = exports.getIsLeadBuyerField = exports.getBuyerOrgIdField = exports.getBuyerNameField = exports.sortBuyerBoxes = exports.sortBySpecificOrder = exports.compareByBoolean = exports.compareByString = exports.BUYER_FIELD_ORDER = exports.BuyerBoxFieldNames = exports.getDate = exports.getField = exports.getFirstBox = void 0;
const tender_box_1 = require("../../schema/matching/tender-box");
const tender_1 = require("../../tender");
function getFirstBox(boxes) {
    var _a;
    return (_a = boxes === null || boxes === void 0 ? void 0 : boxes.at(0)) !== null && _a !== void 0 ? _a : undefined;
}
exports.getFirstBox = getFirstBox;
function getField(tenderBox, fieldNumber) {
    var _a, _b;
    return (_b = (_a = tenderBox === null || tenderBox === void 0 ? void 0 : tenderBox.fields) === null || _a === void 0 ? void 0 : _a.at(fieldNumber)) !== null && _b !== void 0 ? _b : undefined;
}
exports.getField = getField;
function getDate(field) {
    var _a;
    return (field === null || field === void 0 ? void 0 : field.type) === tender_box_1.ProcurementBoxFieldType.Date ? (_a = field === null || field === void 0 ? void 0 : field.date) !== null && _a !== void 0 ? _a : undefined : undefined;
}
exports.getDate = getDate;
var BuyerBoxFieldNames;
(function (BuyerBoxFieldNames) {
    BuyerBoxFieldNames["NAME"] = "Procuring agency";
    BuyerBoxFieldNames["ORG_ID"] = "Procuring agency's national ID";
    BuyerBoxFieldNames["IS_LEAD_BUYER"] = "Is lead buyer";
})(BuyerBoxFieldNames = exports.BuyerBoxFieldNames || (exports.BuyerBoxFieldNames = {}));
exports.BUYER_FIELD_ORDER = [BuyerBoxFieldNames.NAME, BuyerBoxFieldNames.ORG_ID, BuyerBoxFieldNames.IS_LEAD_BUYER];
function compareByString(name, a, b) {
    var _a, _b;
    const aField = a.fields.find((field) => field.name === name);
    const bField = b.fields.find((field) => field.name === name);
    if (aField === undefined && bField === undefined)
        return 0;
    if (aField === undefined)
        return 1;
    if (bField === undefined)
        return -1;
    const aStr = aField.type === tender_1.TenderBoxFieldType.String ? (_a = aField === null || aField === void 0 ? void 0 : aField.string) !== null && _a !== void 0 ? _a : undefined : undefined;
    const bStr = bField.type === tender_1.TenderBoxFieldType.String ? (_b = bField === null || bField === void 0 ? void 0 : bField.string) !== null && _b !== void 0 ? _b : undefined : undefined;
    if (aStr === undefined && bStr === undefined)
        return 0;
    if (aStr === undefined)
        return 1;
    if (bStr === undefined)
        return -1;
    return aStr.localeCompare(bStr);
}
exports.compareByString = compareByString;
function compareByBoolean(name, a, b) {
    var _a, _b;
    const aField = a.fields.find((field) => field.name === name);
    const bField = b.fields.find((field) => field.name === name);
    if (aField === undefined && bField === undefined)
        return 0;
    if (aField === undefined)
        return 1;
    if (bField === undefined)
        return -1;
    const aBool = aField.type === tender_1.TenderBoxFieldType.Boolean ? (_a = aField.boolean) !== null && _a !== void 0 ? _a : undefined : undefined;
    const bBool = bField.type === tender_1.TenderBoxFieldType.Boolean ? (_b = bField.boolean) !== null && _b !== void 0 ? _b : undefined : undefined;
    if (aBool === undefined && bBool === undefined)
        return 0;
    if (aBool && !bBool)
        return -1;
    if (!aBool && bBool)
        return 1;
    if (aBool === undefined && bBool !== undefined)
        return -1;
    if (aBool !== undefined && bBool === undefined)
        return 1;
    return 0;
}
exports.compareByBoolean = compareByBoolean;
function sortBySpecificOrder(box, order) {
    const orderMap = new Map();
    order.forEach((field, index) => {
        orderMap.set(field, index);
    });
    const fields = [...box.fields].sort((a, b) => {
        const indexA = orderMap.get(a.name);
        const indexB = orderMap.get(b.name);
        if (indexA === undefined && indexB === undefined)
            return 0;
        if (indexA === undefined)
            return 1;
        if (indexB === undefined)
            return -1;
        return indexA - indexB;
    });
    return { ...box, fields };
}
exports.sortBySpecificOrder = sortBySpecificOrder;
/**
 * Make sure buyer boxes (speficicationId = 'PROCURING_AGENCY') always get same sorting order
 * @param boxes
 * @returns
 */
function sortBuyerBoxes(boxes) {
    return [...boxes]
        .sort((a, b) => {
        // Put leader buyer first
        // prioritization: true -> undefined or null -> false
        const leadBuyerComparison = compareByBoolean(BuyerBoxFieldNames.IS_LEAD_BUYER, a, b);
        if (leadBuyerComparison !== 0)
            return leadBuyerComparison;
        // Subsort by org name
        const nameComparison = compareByString(BuyerBoxFieldNames.NAME, a, b);
        if (nameComparison !== 0)
            return nameComparison;
        // Subsort by org id
        return compareByString(BuyerBoxFieldNames.ORG_ID, a, b);
    })
        .map((box) => {
        // Sort fields with specific order
        return sortBySpecificOrder(box, exports.BUYER_FIELD_ORDER);
    });
}
exports.sortBuyerBoxes = sortBuyerBoxes;
function getBuyerNameField(fields) {
    return fields.find((field) => field.name === BuyerBoxFieldNames.NAME);
}
exports.getBuyerNameField = getBuyerNameField;
function getBuyerOrgIdField(fields) {
    return fields.find((field) => field.name === BuyerBoxFieldNames.ORG_ID);
}
exports.getBuyerOrgIdField = getBuyerOrgIdField;
function getIsLeadBuyerField(fields) {
    return fields.find((field) => field.name === BuyerBoxFieldNames.IS_LEAD_BUYER);
}
exports.getIsLeadBuyerField = getIsLeadBuyerField;
function getBuyerName(fields) {
    var _a, _b;
    return (_b = (_a = getBuyerNameField(fields)) === null || _a === void 0 ? void 0 : _a.string) !== null && _b !== void 0 ? _b : undefined;
}
exports.getBuyerName = getBuyerName;
function getBuyerOrgId(fields) {
    var _a, _b;
    return (_b = (_a = getBuyerOrgIdField(fields)) === null || _a === void 0 ? void 0 : _a.string) !== null && _b !== void 0 ? _b : undefined;
}
exports.getBuyerOrgId = getBuyerOrgId;
function getIsLeadBuyer(fields) {
    var _a, _b;
    return (_b = (_a = getIsLeadBuyerField(fields)) === null || _a === void 0 ? void 0 : _a.boolean) !== null && _b !== void 0 ? _b : undefined;
}
exports.getIsLeadBuyer = getIsLeadBuyer;
function getCombinedBoxId(boxId, bidId) {
    return `${bidId}#PROCURING_AGENCY#${boxId}`;
}
exports.getCombinedBoxId = getCombinedBoxId;
